import { Box, Chip, Divider, List, ListItem } from "@mui/material";
import { PickersShortcutsProps } from "@mui/x-date-pickers-pro";

/** Shared shortcut-chip renderer, generic over single `DatePicker` and `DateRangePicker` values. */
export function DateShortcutChips<TValue>(props: PickersShortcutsProps<TValue>) {
  const { items, onChange, isValid, changeImportance = "accept" } = props;

  if (items == null || items.length === 0) {
    return null;
  }

  const resolvedItems = items.map((item) => {
    const newValue = item.getValue({ isValid });
    return {
      label: item.label,
      onClick: () => {
        onChange(newValue, changeImportance, item);
      },
      disabled: !isValid(newValue),
    };
  });

  return (
    <Box sx={{ width: "100%", gridRow: 1, gridColumn: 2 }}>
      <List
        dense
        sx={(theme) => ({
          display: "flex",
          justifyContent: "center",
          px: theme.spacing(2),
          "& .MuiListItem-root": {
            width: "inherit",
            py: 0,
            px: theme.spacing(0.5),
          },
        })}
      >
        {resolvedItems.map((item) => (
          <ListItem key={item.label}>
            <Chip {...item} />
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );
}
